import {
    type ComponentType,
    createContext,
    useContext,
    useEffect,
    type FC
} from "react";
import type {
    AttachmentPartContentProps,
    AttachmentGroupContextType,
    AttachmentContextType
} from "./type";
import {
    warnOnce
} from "../../utils/development";

export const AttachmentContext = createContext<AttachmentContextType | null>(null);

export const AttachmentGroupContext = createContext<AttachmentGroupContextType | null>(null);

export const useAttachmentContext = () => {
    return useContext(AttachmentContext);
};

export const useAttachmentGroupContext = () => {
    return useContext(AttachmentGroupContext);
};

export const withAttachmentContext = <P extends object>(
    part: string,
    Content: ComponentType<AttachmentPartContentProps<P>>
): FC<P> => {
    const AttachmentPart: FC<P> = (props) => {
        const context = useAttachmentContext();

        useEffect(() => {
            if(context) {
                return;
            }

            warnOnce({
                message: `Attachment.${part}: it must be rendered inside an Attachment.`
            });
        }, [
            context
        ]);

        if(!context) {
            return null;
        }

        return <Content
            {...props}
            context={context}
        />;
    };

    AttachmentPart.displayName = `Attachment.${part}`;

    return AttachmentPart;
};
